import FilePickerActionsPanelViewState from '../../store/schema/FilePickerActionsPanelViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('showHideActionsPanelCallout')(function showHideActionsPanelCallout(
    shouldShow: boolean,
    viewState: FilePickerActionsPanelViewState
) {
    viewState.isCalloutVisible = shouldShow;
});
